import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Layout } from 'features/common/components/Layout';
import { TransactionDetailsView } from 'features/transaction-details/components/TransactionDetailsView';

const parseQueryInt = (value: string | null | undefined): number | undefined => {
	if (value === null || value === undefined || value === '') {
		return undefined;
	}
	const parsed = parseInt(value, 10);
	return Number.isNaN(parsed) ? undefined : parsed;
};

const TransactionDetails = (): JSX.Element => {
	const { id } = useParams<{ id: string }>();
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);

	const transactionId = parseQueryInt(id) ?? 0;
	const highlightAuthorizationId =
		parseQueryInt(searchParams.get('highlightAuth')) ?? parseQueryInt(searchParams.get('auth'));
	const highlightEticket = searchParams.get('highlightEticket') ?? undefined;

	return (
		<Layout>
			<TransactionDetailsView
				transactionId={transactionId}
				highlightAuthorizationId={highlightAuthorizationId}
				highlightEticket={highlightEticket}
			/>
		</Layout>
	);
};

export default TransactionDetails;
